// extracted by mini-css-extract-plugin
module.exports = {"irt":"FbackList_style_irt__FM8Vq"};